import { skipToken } from '@reduxjs/toolkit/dist/query';

import { announcementsApi } from 'apis/announcements';
import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughAnnouncementProps = {
  node: ConversationFlowAuditLogEntry<'ANNOUNCEMENT_NODE_VISITED'>;
};

export function RoutedThroughAnnouncement({
  node,
}: RoutedThroughAnnouncementProps): JSX.Element {
  const id = node.announcement?.split('/').pop()?.split('.')[0];
  const { data } = announcementsApi.useReadAnnouncementQuery(
    id ? { id } : skipToken,
  );

  return (
    <>
      Audio message · <strong>{data?.data.name || node.label}</strong> is played
    </>
  );
}
